import React from 'react';
import * as S from './PriceAndContacts.styles';
import { useServerDataContext } from '@/contexts';
import { useAdDetails } from '@/hooks/useAdDetails';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { formatNumber } from '@/utils/helpers';
import { CallButton } from '@/components/Ad/CallButton/CallButton';
import { ChatButton } from '@/components/Ad/ChatButton/ChatButton';

export const PriceAndContacts = () => {
  const { initialAdDetails } = useServerDataContext();
  const { adDetails } = useAdDetails();
  const adData = adDetails ?? initialAdDetails;

  const { price } = adData ?? {};

  function getPrice() {
    if (price === undefined) {
      return (
        <SkeletonLoader
          dataTestId="ad-price-skeleton-loader"
          borderRadius={14}
          width="170px"
          height="28.8px"
        />
      );
    }

    if (price === null || price === 0) {
      return null;
    }

    return (
      <S.Price data-testid={AdPageTestIds.price}>
        {formatNumber(price, 2, true)} ₼
      </S.Price>
    );
  }

  return (
    <S.Container>
      {getPrice()}
      <S.ContactsContainer>
        <CallButton />
        <ChatButton />
      </S.ContactsContainer>
    </S.Container>
  );
};
